import { onMounted, shallowRef } from 'vue';

import { IN_BROWSER } from '@components/utils';

import { useDisplay } from './display';

import type { Ref } from 'vue';

export function useHydration(): Ref<boolean> {
  if (!IN_BROWSER) return shallowRef(false);

  const { ssr } = useDisplay();

  if (ssr) {
    const isMounted = shallowRef(false);
    onMounted(() => {
      isMounted.value = true;
    });
    return isMounted;
  } else {
    return shallowRef(true);
  }
}
